/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_HydrationInputs */

const en_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hydration`)
};

const ar_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التفريغ`)
};

const bn_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাইড্রেশন`)
};

const de_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flüssigkeitszufuhr`)
};

const es_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidratación`)
};

const fr_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hydratation`)
};

const pt_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidratação`)
};

const zh_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水合作用`)
};

const tr_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidrasyon`)
};

const ru_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увлажнение`)
};

const pl_svchip_hydration = /** @type {(inputs: Svchip_HydrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nawodnienie`)
};

/**
* | output |
* | --- |
* | "Hydration" |
*
* @param {Svchip_HydrationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_hydration = /** @type {((inputs?: Svchip_HydrationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_HydrationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_hydration(inputs)
	if (locale === "bn") return bn_svchip_hydration(inputs)
	if (locale === "de") return de_svchip_hydration(inputs)
	if (locale === "es") return es_svchip_hydration(inputs)
	if (locale === "fr") return fr_svchip_hydration(inputs)
	if (locale === "pt") return pt_svchip_hydration(inputs)
	if (locale === "zh") return zh_svchip_hydration(inputs)
	if (locale === "tr") return tr_svchip_hydration(inputs)
	if (locale === "ru") return ru_svchip_hydration(inputs)
	if (locale === "pl") return pl_svchip_hydration(inputs)
	return en_svchip_hydration(inputs)
});